import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import useAuthentication from "../../Infrastructure/States/onAuthStateChange";
import { useSelector } from "react-redux";
import DialogBox from "../Common/DialogBox/dialogBox";
import paths from "../../Infrastructure/Router/paths";
import { educatorFaqSX } from "./styles";

const faqData = [
  {
    question: "Why should I become an Educator on the Vulcan Learning platform?",
    answer: "Because you have a passion for teaching and want to turn that into a way to earn money."
  },
  {
    question: "How will learners reach and sign up for my classes?",
    answer: "We will drive traffic to the platform through advertising and organic outreach, in conjunction with educators utilizing their personal brand to attract learners."
  },
  {
    question: "How do I get paid?",
    answer: "After a class is complete, income earned from that class will be distributed to your bank account."
  },
  {
    question: "What fees does the Vulcan Learning platform charge me?",
    answer: "Educators are not charged any fees, they receive 100% of the revenue generated by their classes. We do assess learners a 10% platform fee that they pay when they enroll in a class."
  },
  {
    question: "Can I teach classes in person?",
    answer: "Currently classes can only be taught online/remotely."
  },
  {
    question: "What are the requirements to become an Educator on the Vulcan Learning platform?",
    answer: "You must have some form of teaching experience, which can be from informal tutoring, creating educational content online, being a college professor, or anything in between. You will also have to be accepted through our application process which will consider many factors such as years of experience, demonstrated skill, good character, and personal brand."
  }
];

const EducatorFaq = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { userId } = useAuthentication()
    const [open, setOpen] = React.useState(false);
    const userData = useSelector((state) => state.userData.data);
    const onboardingComplete = userData?.educator?.onboarding_complete;
    const is_educator = userData?.is_educator
    const message = is_educator ? "Educator Onboarding Complete": "Must have Educator Account";

    const navigateToBecomeEdu = async () => {
    if (!userId) {
      navigate(paths.onboardingPage.path, { state: { from: location.pathname } });
    }
    if (is_educator) {
      if (onboardingComplete) {
        setOpen(true);
      } else {
        navigate(paths.onboardingPage.path, { state: { from: location.pathname } });
      }
    } else {
      setOpen(true);
    }
  };
  return (
    <>
    <DialogBox open={open} setOpen={setOpen} message={message} />
    <Box sx={educatorFaqSX.page}>
      <Typography variant="h1" align="center" component="h2" sx={educatorFaqSX.title}>
        Educator FAQ
      </Typography>
      {faqData.map((faq, index) => (
        <Accordion key={index}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon fontSize="small" />}
            aria-controls={`panel${index + 1}a-content`}
            id={`panel${index + 1}a-header`}
          >
            <Typography variant="subtitle1" align="left">{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="subtitle2">{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
      <Box sx={educatorFaqSX.ctaWrapper}>
        <Button
          variant="contained"
          color="primary"
          onClick={navigateToBecomeEdu}
        >
          Become an Educator
        </Button>
      </Box>

    </Box>
    </>
  );
};

export default EducatorFaq;
